import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Google, Facebook, LinkedIn } from '@mui/icons-material';

const AuthSocialButtons = () => {
  const handleSocialLogin = (provider) => {
    // Mock social login - would integrate with actual OAuth providers
    console.log(`Attempting login with ${provider}`);
    // For now, just show an alert
    alert(`Connexion via ${provider} - Fonctionnalité à venir`);
  };

  return (
    <Box className="social-buttons-container">
      <Typography variant="body2" sx={{ textAlign: 'center', mb: 2, color: 'text.secondary' }}>
        Ou inscrivez-vous avec
      </Typography>
      
      <Button
        fullWidth
        variant="outlined"
        onClick={() => handleSocialLogin('Google')}
        className="social-button social-button-google"
        startIcon={<Google />}
      >
        Continuer avec Google
      </Button>
      
      <Button
        fullWidth
        variant="outlined"
        onClick={() => handleSocialLogin('Facebook')}
        className="social-button social-button-facebook"
        startIcon={<Facebook />}
      >
        Continuer avec Facebook
      </Button>
      
      <Button
        fullWidth
        variant="outlined"
        onClick={() => handleSocialLogin('LinkedIn')}
        className="social-button social-button-linkedin"
        startIcon={<LinkedIn />}
      >
        Continuer avec LinkedIn
      </Button>
    </Box>
  );
};

export default AuthSocialButtons;